// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FSn6","clinicsSelect":"styles_clinicsSelect__2bZWs"};